import { eventBus } from '../event-bus';
import { isStudioPage } from './page-utils';

export const isHelpPanelAnywherePage = () => {
  return isStudioPage();
};

export const sendEventToHelpAnywherePanel = (type: string, additionalInfo = {}) => {
  const data = { origin: 'CA', type, additionalInfo };
  eventBus.dispatch('eventToHelpAnywherePanel', data);
};
